import logo from "@/assets/alley-pub-logo.jpg";

// Official Alley Pub logo. The source art has a solid black background;
// `mix-blend-mode: screen` drops the black so it sits cleanly on the dark theme.
export function Logo({ className = "" }) {
  return (
    <img
      src={logo}
      alt="Alley Pub — Bellevue's Best Sports Bar & Grill"
      className={`h-12 md:h-14 w-auto select-none ${className}`}
      style={{ mixBlendMode: "screen" }}
      draggable={false}
    />
  );
}
